var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h24v24H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.02083)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACx0lEQVRoge1Yy05UQRAtX2iC+BEmrhCGaOKg32AUZBiMfoobV0YIiMzoDygP/RgSV4oC4f0BMCbiRq3i3jE3dau7b3X3jC76JCeZ5J6qru7p5wFISEjwwQCyiVxFbiC/56TfK/m3AUeO68h3yGXkVAV9NDSQ28jfDm4hH1nyrDP9tkMfjAvIeUOxNs4hzwv5Tgz61wZ9MF55FN/lrJDvuUW/GLv4htDIKXIJWUcO5hxHtpA/Bf2kkHcs159W1HuBFhef8wfIUUsMFXbIYjbBvFBrec6ifh95Kbx8gBkoj3ytQhx1gv8TDYt+BMr/xBPvqgtYZUmXFLFtFrvs0C8y/QdtsRK+sqR3FLHjLPaLQ3+b6Xe0xUrosKRXFbFDLPbEob/M9D+0xUrgHRhSxF5jsccO/RXoQQf4FKorYu+y2A2H/hbT7yprFbHCkrYUsW9Y7HuHfoHpP2qLldBkSWmrG6sQR6Op2UaHIZsyRf1T76oLoMNniyWmQ8rWCdpNjljMNzAfTDeRe0Ib0W6okyw5kUaX9nma57SwaXe6h3wL5ZH/hXwg5KVRp72fjzxxKlbxXcwJjVTlCyHfM8g6JunbsYsn0BV31qP4lyBfj48N+pZBHw0TkF3MXIXTnH9oyfOJ6WkNNHtWNQMtRtpR6G5D14NOzs+QbZUNcN8kbyDXINsqH0N2iCUkJEQCnYD0Eiv6Pr5nQJd9842moZrvE0q6ntge7pJvZH3ok+/Db4P9oNY3InvnnNQBH9MqFrW+0QIXV/F9QlH0jSQfaEKIoRtv26D/ezk0+T5VrBNfaH0jSb+LvEgf+YOFrrY20yoWJN9o2qKvmfQhvk8otL5Ri+nPnqghvk8ouG/kevTXoTztgnyfUHDfqOPQDzI9HY6l1d1vaNsv6VMHApE6UDwgDntToxXa9kv6+5CZUEf5735D2/6/rjch4b/CH7lOPLGcj2K2AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ed4e704d1200574ff5d9c57d200ec926.svg";
export { ForwardRef as ReactComponent };